<template>
  <div style="height:100%;margin-top: 50px;">  <!--适配4k屏-->
      <!--富文本编译器-->
      <div style="height: calc(100% - 264px - 70px);" id="articleEditor">   <!--适配4k屏-->
          <editor id="tinymce" v-model="context" :init="init"></editor>
          <div style="width: 100%;height: 264px;background-color:rgba(249, 249, 249, 1);margin-bottom: 70px">
              <div style="width: 840px;height: 264px;background-color: white;margin: auto;box-shadow: 4px 4px 10px 1px rgba(166, 166, 166, 0.25);">
                  <!--分割线-->
                  <div style="width: 608px;height: 1px;background-color: rgba(229, 229, 229, 1);margin-left: 115px;margin-right: 117px"></div>
                  <!--封面简介-->
                  <div style="width: 608px;margin-left: 115px;margin-right: 117px;margin-top: 20px">
                      <create-cover-and-introduction :introduction="contextBrief" introductionNum="40" @changeIntroduction="changeIntroduction"
                                                     :coverSrc="contextImg" @editCoverOK="editCoverOK"></create-cover-and-introduction>
                  </div>
                  <div style="display:flex;width: 608px;margin-left: 115px;margin-right: 117px;margin-top: 20px">
                      <create-position :positionGeoName="geoName" :positionGeoJson="geo" @choosePositionOK="choosePositionOK" style="flex:1;"></create-position>
                      <create-public-switch :publicStatus="contextStatus" @changePublicStatus="changePublicStatus" style="flex:1;padding-left:43px;"></create-public-switch>
                  </div>

              </div>

          </div>
      </div>
      <!--插件区-->

      <!--悬浮按钮组-->
      <div style="position: fixed; bottom: 0;width: 100%;height: 70px;background-color: rgba(249, 249, 249, 1)">
          <div style="width:100%;max-width: 840px;height: 70px;background-color: white;margin: auto;border-top: 2px solid rgba(229, 229, 229, 1);box-shadow: 4px 4px 10px 1px rgba(166, 166, 166, 0.25);">
              <div style="width: 80px;height: 30px;float: right;margin-right: 63px;margin-top: 20px"><v-btn depressed style="background-color: rgba(30, 58, 138, 1);color: white;width: 80px;height: 30px" @click="summitInfo()">
                  {{progressStatus == 0? '提交':'重新提交'}}</v-btn></div>
              <div style="width: 80px;height: 30px; float: right;margin-right: 20px;margin-top: 20px"><v-btn depressed style="background-color: #f5f5f5;width: 80px;height: 30px" @click=" previewDialogShow()"> 预览</v-btn></div>
              <div v-show="progressStatus == 0" style="width: 100px;height: 30px;float: right;margin-right: 20px;margin-top: 20px">
                  <v-btn depressed style="background-color: #f5f5f5;width: 100px;height: 30px" @click="saveDraft()"> 保存草稿</v-btn>
              </div>
          </div>
          <v-snackbar
                  absolute
                  v-model="snackbar"
                  :color="snackbarColor"
                  :timeout="1000"
                  style="bottom: 60px;"
                  min-width="840"
                  max-height="30"
                  elevation="0"
          >
              <div style="width: 840px;text-align: center;font-size: 16px;color: white">
                  {{snackbarText}}
              </div>
          </v-snackbar>
      </div>
      <!--预览弹窗-->
      <v-dialog  v-model="showPreviewDialog" width="807"  style="background-color: transparent;elevation: 0" content-class="preDialog" >
          <div class="float-left" style="width: 320px;height: 320px;position: fixed;background-color: white">
              <v-col align="center">
                  <div ref="qrcode" style="width: 180px;height: 180px; margin-top: 50px;"></div>
                  <div style="font-size: 12px;color: #000000;margin-top: 30px">预览二维码仅供查看编辑效果，短期会失效</div>
              </v-col>
          </div>
          <div class="float-left" style="width: 420px;height: 700px;margin-left: 370px;background-color: white;overflow: hidden">
              <iframe frameborder="0" width="420" style="height: 697px" :src="previewUrl"></iframe>
          </div>
      </v-dialog>
      <!--loading弹窗-->
      <dialog-loading :dialog-show="showDialog"></dialog-loading>

      <!--标题-->
      <div id="editorArea_title" style="width: 100%;height: 90px;background-color:rgba(249, 249, 249, 1);">
          <div style="height:100px;width: 840px;background-color: white;margin: auto;box-shadow: 4px 4px 10px 1px rgba(166, 166, 166, 0.25);padding-top: 40px">
              <div style="position: relative;;background-color: white;height: 34px;margin-left: 115px;margin-right: 117px">
                  <create-title :title="contextTitle" @changeTitle="changeTitle"></create-title>
              </div>
          </div>
      </div>

      <!--遥感影像弹窗-->
      <v-dialog v-model="imageDialogShow" scrollable persistent width="1120">
          <div style="width: 1120px;height: 697px;border-radius: 2px;background-color: white;box-shadow: 0px 0px 4px 2px rgba(0,0,0,0.25);overflow: hidden">
              <!--标题-->
              <div style="width: 100%;height: 70px;box-shadow: 0px 2px 7px 0px rgba(166, 166, 166, 0.25);">
                  <div class="float-left" style="margin-left: 20px;line-height: 70px;font-size: 20px;font-weight: bold;color: black">添加遥感影像</div>
                  <div @click="closeImageDialog"  class="float-right" style="margin-right: 15px;width: 20px;height: 20px;margin-top: 25px"><p style="font-size:10px;color:#A6A6A6;cursor:pointer;" class="iconfontFamily">&#xe60d;</p></div>
              </div>
              <!--中间结果区-->
              <div style="width: 100%;height: 566px">
                  <!--左侧标题区-->
                  <div class="float-left" style="width: 120px;height: 100%;border-right: 1px solid  #E5E5E5;font-size: 14px;letter-spacing: 1px">
                      <div @click="selectDiv('onlineSearch')" style="height: 20px;margin-top: 20px; text-align: center;line-height: 20px;width: 100%;cursor: pointer" :style="{'color':divSelected =='onlineSearch' ? '#1976D2':'#000000'}">在线搜索</div>
                      <div @click="selectDiv('recentlyUsed')" style="height: 20px;margin-top: 20px; text-align: center;line-height: 20px;width: 100%;cursor: pointer" :style="{'color':divSelected =='recentlyUsed' ? '#1976D2':'#000000'}">最近使用</div>
                      <div @click="selectDiv('myCollection')" style="height: 20px;margin-top: 20px; text-align: center;line-height: 20px;width: 100%;cursor: pointer" :style="{'color':divSelected =='myCollection' ? '#1976D2':'#000000'}">我的收藏</div>
                  </div>
                  <!--右侧结果区-->
                  <div class="float-left" style="width: 1000px;height: 566px;">
                      <div>
                          <!--在线搜索-->
                          <div v-if="resultDivSelected =='searchPage'" style="width: 1000px;height: 100%">
                              <v-card tile flat width="600" style="margin-left: 206px;margin-top: 200px">
                                  <div style="width: 600px;height: 40px">
                                      <v-text-field
                                              v-model="searchKeyWord"
                                              solo
                                              flat
                                              style="height: 40px"
                                              outlined
                                              dense
                                              height="40"
                                              append-icon="mdi-magnify"
                                              label="输入关键词查找影像"
                                              @keyup.enter="enterKeyWord()"
                                      >
                                      </v-text-field>
                                  </div>
                                  <div v-if="searchKeyWord == ''" style="width: 600px;text-align: center;line-height:20px;height: 20px;font-size: 14px;color: rgba(128, 128, 128, 1);margin-top: 33px">影像素材由吉林一号·共生地球提供</div>
                              </v-card>
                              <v-card tile width="600" v-if="searchResultShow &&searchResult.length >0 && searchKeyWord != ''" style="font-size:14px;color:black;margin-left: 206px;padding-top: 6px;padding-bottom: 6px;box-shadow: 0px 2px 4px 0px rgba(166, 166, 166, 0.25);">
                                  <template v-for="(item ,index) in searchResult">
                                      <v-hover :key="index">
                                          <v-card @click="selectKeyWord(item)" slot-scope="{ hover }" style="height: 35px" tile flat :style="{'background-color': hover ? 'rgba(30, 58, 138, 0.05)':'#FFFFFF'}">
                                              <div style="line-height: 35px;padding-left: 19px"> {{item}}</div>
                                          </v-card>
                                      </v-hover>
                                  </template>
                              </v-card>
                          </div>
                          <div v-if="resultDivSelected =='eventPage'" style="width: 1000px;height: 566px;position: relative" >
                              <!--上部区域-->
                              <div v-if="divSelected =='onlineSearch'" style="height: 60px">
                                  <div class="float-right" style="width: 320px;height: 40px;margin-top: 20px;margin-right: 50px">
                                      <v-text-field
                                              v-model="searchKeyWord"
                                              solo
                                              flat
                                              style="height: 40px"
                                              outlined
                                              dense
                                              height="40"
                                              append-icon="mdi-magnify"
                                              label="输入关键词查找影像"
                                              @keyup.enter="enterKeyWord()"
                                              @focus="searchKeyWordFocus"
                                      >
                                      </v-text-field>
                                  </div>
                                  <div style="position: absolute;top: 60px;z-index: 99">
                                      <v-card  tile width="320" v-if="searchResultShow &&searchResult.length >0 && searchKeyWord != ''" style="margin-left:630px;font-size:14px;color:black;padding-top: 6px;padding-bottom: 6px;box-shadow: 0px 2px 4px 0px rgba(166, 166, 166, 0.25);">
                                          <template v-for="(item ,index) in searchResult">
                                              <v-hover :key="index">
                                                  <v-card @click="selectKeyWord(item)" slot-scope="{ hover }" style="height: 35px" tile flat :style="{'background-color': hover ? 'rgba(30, 58, 138, 0.05)':'#FFFFFF'}">
                                                      <div style="line-height: 35px;padding-left: 19px"> {{item}}</div>
                                                  </v-card>
                                              </v-hover>
                                          </template>
                                      </v-card>
                                  </div>
                              </div>
                              <div v-if="eventPageResult.length == 0" style="width:1000px" :style="{'height':divSelected =='onlineSearch'? '506px':'566px'}">
                                  <v-row class="ma-0" style="height: 100%;" align="center" justify="center" >
                                      <v-col class="ma-0" align="center">
                                          <v-img src="../../../assets/article/noResult.png" style="width:88px;height:82px;"></v-img>
                                          <div style="font-size: 16px;color: #A6A6A6;margin-top: 12px">暂无相关影像</div>
                                      </v-col>
                                  </v-row>
                              </div>
                              <div v-if="eventPageResult.length != 0" style="width:1000px;display: flex;overflow-y: scroll;overflow-x: hidden" :style="{'height':divSelected =='onlineSearch'? '506px':'566px'}" @scroll="eventPageScroll($event)" id="eventPage" ref="eventPage">
                                  <div style="width:1000px;margin-left: 20px">
                                      <v-layout row class="ma-0">
                                          <template  v-for="(item,key) in eventPageResult" >
                                              <div @click="selectFile(item)" :key="key" style="cursor:pointer;width: 150px;height: 150px;margin: 20px;border-radius: 2px;border: 1px solid rgba(166, 166, 166, 0.5);position: relative">
                                                  <v-img :src="item.thumb" width="148" height="148" contain></v-img>
                                                  <div style="position: absolute;bottom: 10px;left: 0;width: 150px;line-height:30px;text-align: center;font-size: 14px;font-weight: 600;color: white;overflow: hidden;white-space: nowrap; text-overflow: ellipsis">
                                                      {{item.title}}</div>
                                                  <div style="position: absolute;top: 0px;right: 0px;background: rgba(255, 255, 255, 0.6);border-radius: 0px 0px 0px 3px;width: 35px;height: 35px;line-height: 35px;text-align: center">{{item.materialNumber}}</div>
                                              </div>
                                          </template>
                                      </v-layout>
                                  </div>
                              </div>
                          </div>
                          <div v-if="resultDivSelected =='materialPage'" style="width: 1000px;height: 100%">
                              <div style="height: 60px">
                                  <v-layout class="ma-0" fill-height row align-center>
                                      <p @click="backEvent()" style="font-size:10px;color:#C8C8C8;cursor:pointer;margin-left: 20px" class="iconfontFamily">&#xe617;</p>
                                      <div @click="backEvent()" style="color: rgba(0, 0, 0, 1);font-size: 16px;cursor: pointer;padding-left: 10px"><span style="color: rgba(25, 118, 210, 1)">影像查询列表</span>/{{imageSelected.title}}</div>
                                  </v-layout>
                              </div>
                              <div v-if="materialPageResult.length == 0" style="width:1000px;height: 506px" >
                                  <v-row class="ma-0" style="height: 100%;" align="center" justify="center" >
                                      <v-col class="ma-0" align="center">
                                          <v-img src="../../../assets/article/noResult.png" style="width:88px;height:82px;"></v-img>
                                          <div style="font-size: 16px;color: #A6A6A6;margin-top: 12px">暂无相关影像</div>
                                      </v-col>
                                  </v-row>
                              </div>
                              <div v-if="materialPageResult.length != 0" style="height: 506px;width:1000px;display: flex;overflow-y: scroll;overflow-x: hidden" >
                                  <div style="width:1000px;margin-left: 20px">
                                      <v-layout row class="ma-0">
                                          <template  v-for="(item,key) in materialPageResult" >
                                              <div :key="key" style="width: 150px;height: 150px;margin: 0px 20px 20px 20px;border-radius: 2px;border: 1px solid rgba(166, 166, 166, 0.5);position: relative">
                                                  <v-img :src="item.jpgThumb" width="148" height="148" contain></v-img>
                                                  <div @click="addImgToList(item)" style="position: absolute;top: 5px;right: 5px;width: 24px;height: 24px;cursor: pointer;text-align: center;line-height: 24px;border-radius: 2px;background: white;box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);">
                                                      <span style="font-size:15px;color:black;" class="iconfontFamily">&#xe60b;</span>
                                                  </div>
                                              </div>
                                          </template>
                                      </v-layout>
                                  </div>
                              </div>
                          </div>
                          <div v-if="resultDivSelected =='imgSelectedPage'">
                              <div style="height: 60px">
                                  <v-layout class="ma-0" fill-height row align-center>
                                      <p @click="backToPrePage()" style="font-size:10px;color:#C8C8C8;cursor:pointer;margin-left: 20px" class="iconfontFamily">&#xe617;</p>
                                      <div @click="backToPrePage()" style="color: rgba(25, 118, 210, 1);font-size: 16px;cursor: pointer;padding-left: 10px">返回</div>
                                  </v-layout>
                              </div>
                              <div v-if="imageSelectedList.length == 0" style="width:1000px;height: 506px" >
                                  <v-row class="ma-0" style="height: 100%;" align="center" justify="center" >
                                      <v-col class="ma-0" align="center">
                                          <v-img src="../../../assets/article/noResult.png" style="width:88px;height:82px;"></v-img>
                                          <div style="font-size: 16px;color: #A6A6A6;margin-top: 12px">暂无相关影像</div>
                                      </v-col>
                                  </v-row>
                              </div>
                              <div v-if="imageSelectedList.length != 0" style="height: 506px;width:1000px;display: flex;overflow-y: scroll;overflow-x: hidden" >
                                  <div style="width:1000px;margin-left: 20px">
                                      <v-layout row class="ma-0">
                                          <template v-for="(item,key) in imageSelectedList" >
                                              <div :key="key" style="width: 150px;height: 150px;margin: 0px 20px 20px 20px;border-radius: 2px;border: 1px solid rgba(166, 166, 166, 0.5);position: relative">
                                                  <v-img :src="item.jpgThumb" width="150" height="150"></v-img>
                                                  <div @click="deleteMaterialFromList(item)" style="position: absolute;top: 5px;right: 5px;width: 24px;height: 24px;cursor: pointer;text-align: center;line-height: 24px;border-radius: 2px;background: white;box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);">
                                                      <span style="font-size:15px;color:black;" class="iconfontFamily">&#xe60d;</span>
                                                  </div>
                                              </div>
                                          </template>
                                      </v-layout>
                                  </div>
                              </div>
                          </div>
                      </div>

                  </div>
              </div>
              <!--底栏-->
              <div style="height: 60px;width: 1120px;border-top: 1px solid  #E5E5E5">
                  <div @click="viewSelectedImg()" style="font-size: 16px;float: left;color: black;line-height: 60px;margin-left: 25px;width: 180px;cursor: pointer">当前已添加 <span style="color: #2A82E4">{{imageSelectedList.length}}/9</span>项</div>
                  <div style="height: 30px;width: 80px;float: right;margin-top: 15px;margin-right: 25px">
                      <v-btn @click="submitToTinymce()" depressed :color="imageSelectedList.length == 0? '#8F9DC5':'#1E3A8A'" style="width: 80px;height: 30px;color: white">确认</v-btn>
                  </div>
                  <div style="height: 30px;width: 80px;float: right;margin-top: 15px;margin-right: 16px">
                      <v-btn depressed style="background-color: #f5f5f5;width: 80px;height: 30px" @click="closeImageDialog">取消</v-btn>
                  </div>
              </div>
          </div>
      </v-dialog>
  </div>

</template>

<script>
  //注册组件
  import tinymce from 'tinymce/tinymce'
  import Editor from '@tinymce/tinymce-vue'
  import 'tinymce/themes/silver/theme'
  import '../../../../public/tinymce/plugins/axupimgs'
  import '../../../../public/tinymce/plugins/formatpainter'
  import '../../../../public/tinymce/plugins/indent2em'
  //import '../../../../public/tinymce/plugins/tinymceplaceholder'
  // import 'tinymce/themes/mobile'
  import 'tinymce/icons/default/icons'
  import '../../../lib/tinymcePluginimage'
  //import 'tinymce/plugins/link'
  import 'tinymce/plugins/code'
  import 'tinymce/plugins/table'
  import 'tinymce/plugins/lists'
  import 'tinymce/plugins/contextmenu'
  import 'tinymce/plugins/wordcount'
  import 'tinymce/plugins/colorpicker'
  import 'tinymce/plugins/textcolor'
  import 'tinymce/plugins/hr'
  import 'tinymce/plugins/autoresize'
  import 'tinymce/plugins/noneditable'
  import DialogLoading from '/src/components/loading/DialogLoading'
  import CreateTitle from '/src/components/create_page/CreateTitle'
  import CreateCoverAndIntroduction from '/src/components/create_page/CreateCoverAndIntroduction';
  import CreatePosition from '/src/components/create_page/CreatePosition';
  import CreatePublicSwitch from '/src/components/create_page/CreatePublicSwitch';

  import QRCode from 'qrcodejs2'
  export default {
    data() {
      return{
        videoThumbSrc:"",   //上传视频时缩略图的临时路径
        context:'',
        videoTpey:2,
        init: {
          //height: 1000,
          language_url: 'tinymce/langs/zh_CN.js',
          height:800,
          autoresize_bottom_margin:90,
          min_height: 800,
          autoresize_overflow_padding: 100,
          language: 'zh_CN',
          font_formats:"Arial=arial,helvetica,sans-serif; OPPO Sans(未测试)=OPPO SANS; 宋体=宋体;黑体=黑体;微软雅黑=微软雅黑;",
          skin_url: 'tinymce/skins/ui/oxide',  //skin_url指向之前复制出来的 skin 文件
          content_css:'tinymce/skins/content/default/content.css',//这个也加上，不然会报错
          content_style: "p {margin: 0px; padding: 0px} img {max-width:608px;height:auto;}",
          branding: false,
          menubar: false,
          resize:false,
          statusbar:false,
          plugins: 'lists image code table colorpicker textcolor wordcount contextmenu axupimgs formatpainter hr indent2em autoresize noneditable',
          toolbar: 'undo redo formatpainter removeformat alignleft aligncenter alignright alignjustify lineheight bullist numlist indent2em fontsizeselect bold italic underline strikethrough forecolor backcolor blockquote hr' +
                  ' imageupload video remotesensingimage allcopy',
          // inline: true,
          //配置上传图片
         //images_upload_handler: this.uploadImage,
          //file_picker_types:'media',
          toolbar_sticky:true,
          placeholder:"内容正文",
            object_resizing:'img',
          setup:(editor)=>{
            let _this = this
              _this.myEditor = editor
              editor.ui.registry.addButton('imageupload',{
                  icon: 'image',
                  tooltip:'图片上传',
                  onAction:_this.uploadImage1
              })

              editor.ui.registry.addButton('video',{
                  icon: 'embed',
                  tooltip:'视频上传',
                  onAction:_this.uploadVideo
              })

            editor.ui.registry.addButton('remotesensingimage',{
              text:'遥感影像',
              tooltip:'遥感影像',
              onAction:()=>{
                _this.imageDialogShow = true
              }
            })
            editor.ui.registry.addButton('allcopy',{
              text:'全文复制',
              tooltip:'全文复制',
              onAction:()=>{
                  _this.doCopy();
              }
            })
          },
        },
        myEditor:null,
        showDialog:false,//loading弹窗
        showPreviewDialog:false,//预览弹窗
          isGoOtherDialogShow:false,//跳转弹窗
          snackbar:false,//提示文本
          snackbarColor:'#DC143C',
          snackbarText:'',
          contextTitle:'',//标题
          contextImg:'',//封面
          contextBrief:'',//简介
          geo:'',//geo
          geoName:'',//地点名称
          contextStatus:false,//状态
          contextId:'',//文章Id
          progressStatus:0,//过程状态
          //https://earth.jl1.cn/Article/ArticleSharePage?share=1&mainInfoId=d4972c08ce0c420fbc44e6ecbfc01bba&infoId=d4972c08ce0c420fbc44e6ecbfc01bba
          previewUrl:'',
          previewId:'',
          imageDialogShow:false,//遥感影像弹窗
          imageSelectedList:[],//被选择的图片
          imageSelected:{},
          divSelected:"onlineSearch",//导航栏选择
          resultDivSelected:'searchPage',//结果页面选择
          searchKeyWord:'',//搜索关键词
          searchResultShow:true,
          savedSearchKeyWord:'',
          searchResult:[],//联想搜索结果
          eventPageResult:[],//事件搜索结果
          materialPageResult:[],//图片素材结果
          savedPage:'',//是否查看被选中的结果
          currentPageNum:1,
          totalPageNum:0,
          loadMoreFlag:false,
      }
    },
    components: {
      Editor,
      DialogLoading,
        CreateTitle,
        CreateCoverAndIntroduction,
        CreatePosition,
        CreatePublicSwitch
    },
  name: "Article",
    watch:{
      context(){
        if(this.context.indexOf('src="data:image') !== -1){
          this.showDialog = true
          //有base64编码的图片，只会有一个
          let cutIndex = this.context.indexOf('src="data:image');
          let base64Begin = this.context.slice(cutIndex+5,this.context.length);
          let base64 = base64Begin.slice(0,base64Begin.indexOf('"'));
          let file = this.$utils.base64ToFile(base64,"测试图片.jpg");
          let paramData = new FormData();
          paramData.append('multipartFile',file);
          this.$axios.post('/managerApi/upoladFile/uploadPiture',paramData)
                  .then((resultData)=>{
                    resultData = resultData.data;
                    if(resultData.status === 200){
                      //拼接base64图片为http图片路径
                      let contextHtml = this.context.slice(0,cutIndex+5) + resultData.data.picture + '" width="100%" height="auto"' + this.context.slice(cutIndex+5+base64.length+1,this.context.length);
                      this.context = contextHtml;
                      this.$emit("changeContext", {
                        // context:"",
                        contextHtml:contextHtml
                      });
                      this.showDialog = false
                    }else{
                      this.showDialog = false
                    }
                  })
                  .catch(()=>{
                    this.showDialog = false
                  })
        }
        else{
          //没有base64编码图片，不用处理
          this.$emit("changeContext", {
            // context:"",
            contextHtml:this.context
          });
        }
        // if(this.context.indexOf("<video") !== -1 && this.context.indexOf("<source src") !== -1){
        //   //有视频，把视频缩略图拼进去
        //   let cutIndex = this.context.indexOf("<source src");   //只有一个
        //   let contextHtml = this.context.slice(0,cutIndex+7) + ' thumb="' + this.videoThumbSrc + '"' + this.context.slice(cutIndex+7,cutIndex.length)
        //   this.context = contextHtml;
        //   this.$emit("changeContext", {
        //     // context:"",
        //     contextHtml:contextHtml
        //   });
        // }
        // else {
        //   //没有视频，不用处理
        //   this.$emit("changeContext", {
        //     // context:"",
        //     contextHtml:this.context
        //   });
        // }

        // //没有视频，不用处理
        // this.$emit("changeContext", {
        //   // context:"",
        //   contextHtml:this.context
        // });

      },
        showPreviewDialog(){
          if(!this.showPreviewDialog){
              this.$refs.qrcode.innerHTML = ''
          }
        },
        searchKeyWord(){
          if(this.searchKeyWord !==''&& this.savedSearchKeyWord !== this.searchKeyWord){
              this.searchResultShow = true
              this.getSearchAssociation(this.searchKeyWord)
          }
        },
    },
    methods:{
        //删除
        deleteMaterialFromList(item){
            let index  = this.imageSelectedList.indexOf(item)
            if(index !== -1){
                this.imageSelectedList.splice(index,1)
            }
        },
        //搜索框焦点事件
        searchKeyWordFocus(){
            this.savedSearchKeyWord = ''
        },
        //联想方法
        getSearchAssociation(keyword){
            this.$axios.get('/authorApi/z-image-collection/getMoreByKeyWord',{
                params:{
                    keyWord:keyword
                }
            }).then((res)=>{
                if(res.data.status == 200){
                    this.searchResult = res.data.data
                }
            })
        },
        //搜索结果
        getImageList(keyword){
            this.eventPageResult = []
           // this.showDialog = true
            this.$axios.get('/authorApi/z-image-collection/getListByKeywordArticle',{
                params:{
                    keyWord:keyword
                }
            }).then((res)=>{
                if(res.data.status == 200){
                    this.eventPageResult = res.data.data
               //     this.showDialog = false
                }else{
              //      this.showDialog = false
                }
            }).catch(()=>{
             //   this.showDialog = false
            })
        },
        //关闭遥感影像弹窗方法
        closeImageDialog(){
            this.imageDialogShow = false
            this.divSelected="onlineSearch"//导航栏选择
            this.resultDivSelected='searchPage'//结果页面选择
            this.searchKeyWord =''//搜索关键词
            this.searchResultShow=false
            this.savedSearchKeyWord=''
            this. imageSelectedList=[]//选中结果
            this.searchResult=[]//联想搜索结果
            this.eventPageResult =[]
        },
        //选择Div选项卡
        selectDiv(val){
            this.divSelected = val;
            if(val == 'onlineSearch'){
                this.resultDivSelected = 'searchPage'
                this.savedPage = 'searchPage'
                this.searchKeyWord = ''
                this.searchResultShow = false
            }else if(val == 'recentlyUsed'){
                this.resultDivSelected = 'eventPage'
                this.savedPage = 'eventPage'
                this.getRecentlyUsed()
            }else if(val == 'myCollection'){
                this.resultDivSelected = 'eventPage'
                this.savedPage = 'eventPage'
                this.getMyCollection(1,1)
            }
        },
        //最近使用
        getRecentlyUsed(){
            this.eventPageResult = []
         //   this.showDialog = true
            this.$axios.get('/authorApi/z-image-collection/getUserUse')
                .then((res)=>{
                    if(res.data.status === 200){
                        this.eventPageResult = res.data.data
                       // this.showDialog = false
                    }else{
                      //  this.showDialog = false
                    }
                }).catch(()=>{
                //this.showDialog = false
            })
        },
        //我的收藏
        getMyCollection(currentPage,type){
            if(type === 1)
                this.eventPageResult = []
            this.$axios.get('/authorApi/z-image-collection/getUserCollectList',{
                params:{
                    curPageNum:currentPage,
                    maxResultNum:20,
                    status:1
                }
            }).then((res)=>{
                if(res.data.status === 200){
                    if(type ===1){
                        this.eventPageResult = res.data.data.list
                    }else{
                        this.eventPageResult = this.eventPageResult.concat(res.data.data.list)
                    }
                    this.currentPageNum = currentPage
                    this.totalPageNum = res.data.data.totalPageNum
                }
                this.loadMoreFlag = false
            })
        },
        //选择keyword
        selectKeyWord(val){
            this.searchKeyWord = val
            this.savedSearchKeyWord = val
            this.resultDivSelected = 'eventPage'
            this.savedPage = 'eventPage'
            this.searchResultShow = false
            this.getImageList(this.searchKeyWord)

            /*
            * 要进入搜索结果页面了
            * */
        },
        //搜索框回车事件
        enterKeyWord(){
            if(this.searchKeyWord !=''){
                this.savedSearchKeyWord = this.searchKeyWord
                this.resultDivSelected = 'eventPage'
                this.savedPage = 'eventPage'
                this.searchResultShow = false
                this.getImageList(this.searchKeyWord)
            }
        },
        //查看选中照片
        viewSelectedImg(){
            this.resultDivSelected = 'imgSelectedPage'
        },
        //返回上一页
        backToPrePage(){
            this.resultDivSelected = this.savedPage
        },
        //选择文件夹
        selectFile(item){
            this.imageSelected = item
            this.$axios.get('/authorApi/z-image-collection/getMaterialListById',{
                params:{
                    mainId:item.mainId
                }
            }).then((res)=>{
                if(res.data.status ==200){
                    this.materialPageResult = res.data.data
                    this.resultDivSelected = 'materialPage'//进入结果页
                    this.savedPage ='materialPage'
                }
            })
        },
        //返回事件页
        backEvent(){
          this.resultDivSelected = 'eventPage'
            this.savedPage ='eventPage'
        },
        addImgToList(val){
            if(this.imageSelectedList.length <9){
              this.imageSelectedList.push(val)
              this.$store.state.snackbarShow=true
              this.$store.state.snackbarText = "添加成功"
              this.$store.state.snackbarType = 'success'
            }else{
              this.$store.state.snackbarShow=true
              this.$store.state.snackbarText = "最多添加9张"
              this.$store.state.snackbarType = 'error'

            }

        },
        //提交到富文本
        submitToTinymce(){
            if(this.imageSelectedList.length !== 0){
                this.addImgToTinymce(this.imageSelectedList);
            }
        },
        //滚动监听
        eventPageScroll(){
            this.loadMoreFlag= false
            if(this.divSelected ==='myCollection'){
                this.$nextTick(()=>{
                    let element = document.getElementById('eventPage')
                    let scrollHeight = element.scrollHeight;
                    //let clientHeight = element.clientHeight;
                    let scrollTop = element.scrollTop;
                    let offsetHeight = element.offsetHeight
                    if(scrollTop+offsetHeight- scrollHeight>= 0 &&  !this.loadMoreFlag){
                        this.loadMoreFlag = true
                        if(this.currentPageNum < this.totalPageNum){
                            this.getMyCollection(this.currentPageNum+1,2)
                        }
                    }
                });
            }

        },

        //添加图片
        addImgToTinymce(list){
            let html = '';
            let idList= []
            for(let i = 0; i<list.length; i++){
                html +=`<img src=${list[i].jpg} width="100%" height="100%"/>`
                idList.push(list[i].mainId)
            }
            tinymce.activeEditor.insertContent(html)
            this.addUserUse(idList)
            this.closeImageDialog()
        },
        //最近使用
        addUserUse(list){
            let data= new FormData()
            data.append('mainIdList',list.toString())
            this.$axios.post('/authorApi/z-image-collection/addUserUse',data)
        },

        //默认配置方法
        uploadImage(blobInfo, succFun, failFun){
          if(blobInfo.blob().size/1024/1024 > 5){
            this.$store.state.snackbarShow=true
            this.$store.state.snackbarText = "文件大小不能超过5M"
            this.$store.state.snackbarType = 'error'

            failFun('文件大小不能超过5M')
          }else{
              let file = blobInfo.blob();
              let paramData = new FormData();
              paramData.append('multipartFile',file);
              this.$axios.post('/managerApi/upoladFile/uploadPiture',paramData)
                  .then((resultData)=>{
                      resultData = resultData.data;
                      if(resultData.status === 200){
                          succFun(resultData.data.picture);
                      }
                      else{
                          failFun("上传失败，请稍后重试")
                      }
                  })
                  .catch(()=>{

                  })
          }

      },
        //自定义上传图片
        uploadImage1(){
            let _this = this
            let input = document.createElement('input');
            input.setAttribute('type', 'file')
            input.setAttribute("accept", "image/jpeg,image/jpg,image/png");
            //input.setAttribute("multiple" ,true);
            input.onchange = function() {
                let file = this.files[0];
                if(file.type !== "image/jpeg" && file.type !== "image/jpg" && file.type !== "image/png"){
                  _this.$store.state.snackbarShow=true
                  _this.$store.state.snackbarText = "文件必须为以下格式：jpg、png、jpeg"
                  _this.$store.state.snackbarType = 'error'
                }else if(file.size > 1024 * 1024 * 10){
                  _this.$store.state.snackbarShow=true
                  _this.$store.state.snackbarText = "文件大小不能超过10M"
                  _this.$store.state.snackbarType = 'error'
                }else{
                    _this.showDialog=true;
                    let paramData = new FormData();
                    paramData.append('multipartFile',file);
                    _this.$axios.post('/managerApi/upoladFile/uploadPiture',paramData)
                        .then((resultData)=>{
                            resultData = resultData.data;
                            if(resultData.status == 200){
                                _this.addSingleImgToTinymce(resultData.data.picture)
                                _this.showDialog=false;
                            }else{
                              _this.showDialog=false;
                              _this.$store.state.snackbarShow=true
                              _this.$store.state.snackbarText = "图片上传失败，请重试"
                              _this.$store.state.snackbarType = 'error'
                            }
                        }) .catch(()=>{
                        _this.showDialog=false;
                      _this.$store.state.snackbarShow=true
                      _this.$store.state.snackbarText = "视频上传失败，请重试"
                      _this.$store.state.snackbarType = 'error'

                    })
                }
            }
            input.click();
        },
        //上传视频
        uploadVideo(){
            let _this = this
            let input = document.createElement('input');
            input.setAttribute('type', 'file');
            input.setAttribute("accept", "video/mp4");
            input.onchange = function() {
                let file = this.files[0];
                if(file.type !== "video/mp4" && file.type !== "video/wmv" && file.type !== "video/avi"){
                  _this.$store.state.snackbarShow=true
                  _this.$store.state.snackbarText = "文件必须为以下格式：avi、wmv、mp4"
                  _this.$store.state.snackbarType = 'error'
                }
                else if(file.size > 1024 * 1024 * 500){
                  _this.$store.state.snackbarShow=true
                  _this.$store.state.snackbarText = "文件大小不能超过500M"
                  _this.$store.state.snackbarType = 'error'

                }else{
                    _this.showDialog=true;
                    let data = new FormData()
                    data.append('multipartFile',file)
                    data.append('userId','')
                    _this.$axios.post('/managerApi/upoladFile/uploadVideo',data)
                        .then((resultData)=>{
                            resultData = resultData.data;
                            if(resultData.status == 200){
                                //接口返回的文件保存地址
                                //_this.videoThumbSrc = resultData.data.thumb;
                                _this.addVideoToTinymce(resultData.data.picture,resultData.data.thumb)
                                _this.showDialog=false;
                            }else{
                                _this.showDialog=false;
                              _this.$store.state.snackbarShow=true
                              _this.$store.state.snackbarText = "视频上传失败，请重试"
                              _this.$store.state.snackbarType = 'error'
                            }
                        })
                        .catch(()=>{
                            _this.showDialog=false;
                          _this.$store.state.snackbarShow=true
                          _this.$store.state.snackbarText = "视频上传失败，请重试"
                          _this.$store.state.snackbarType = 'error'

                        })
                }



            }
            input.click();
        },

        //添加视频到内容上
        addVideoToTinymce(src,videoThumbSrc){
          if(src){
              let html = `<p><video controls="controls" width="620" height="auto" style="max-height: 465px;max-width: 620px;width: 100%;background-color: rgba(229, 229, 229, 1);margin: 0 auto;border: #ffffff" poster=${videoThumbSrc}><source src=${src} type="video/mp4" /></video></video></p>`
              tinymce.activeEditor.insertContent(html)
          }
        },
        addSingleImgToTinymce(src){
            if(src){
                let html = `<img src=${src} width="100%" height="100%"/>`
                tinymce.activeEditor.insertContent(html)
            }
        },

        //预览弹窗
        previewDialogShow(){
          //判定
            if(this.contextTitle == ''){
                this.snackbarColor='#CF0000'
                this.snackbar = true
                this.snackbarText = '无法提交，请输入标题'
            }else if(this.contextTitle.length >20){
                this.snackbarColor='#CF0000'
                this.snackbar = true
                this.snackbarText = '标题长度不能超过20字'
            } else if(this.context == ''){
                this.snackbarColor='#CF0000'
                this.snackbar = true
                this.snackbarText = '无法提交，请输入正文'
            }else if(this.contextBrief == ''){
                this.snackbarColor='#CF0000'
                this.snackbar = true
                this.snackbarText = '无法提交，请输入简介'
            } else if(this.contextImg == ''){
                this.snackbarColor='#CF0000'
                this.snackbar = true
                this.snackbarText = '无法提交，请选择封面'
            }else if(this.contextBrief.length > 40){
                this.snackbarColor='#CF0000'
                this.snackbar = true
                this.snackbarText = '简介长度不能超过40字'
            } else if(this.geo == ''){
                this.snackbarColor='#CF0000'
                this.snackbar = true
                this.snackbarText = '无法提交，请选择定位'
            }else{
                this.getPreview()
            }

        },
        //预览接口
        getPreview(){
            let publicStatus = this.contextStatus ? 1 : 0;
            let data = new FormData()
            data.append('mainTitle',this.contextTitle)
            data.append('context',this.context)
            data.append('mainType','1')
            data.append('geo',this.geo)
            data.append('geoName',this.geoName)
            data.append('bubblePicture',this.contextImg)
            data.append('simpleInfo',this.contextBrief)
            data.append('publicStatus',publicStatus)
            data.append('progressStatus',this.progressStatus)
            if(this.previewId != ''){
                data.append('infoId',this.previewId)
            }
            this.$axios.post('/authorApi/main-info/getPreview',data).then((res)=>{
                if(res.data.status == 200){
                    this.previewId = res.data.data
                    //保存草稿
                    if(this.progressStatus == 0){
                        this.savePreviewDraft()
                    }
                    var timestamp = Date.parse(new Date())
                    //正式环境： https://earth.jl1.cn
                    //测试环境：http://121.36.68.139:8080/
                    let url = this.$utils.appH5Url + 'Article/ArticleSharePage?share=1&preview=1&infoId='+this.previewId+'&timestamp='+timestamp
                    this.previewUrl = url
                    this.$nextTick(()=>{
                        this.createQRcode(url)
                    })
                    this.showPreviewDialog = true
                }else{
                  this.$store.state.snackbarShow=true
                  this.$store.state.snackbarText = "请稍后重试"
                  this.$store.state.snackbarType = 'error'
                }
            })
        },
        createQRcode(url){
           new QRCode(this.$refs.qrcode, {
                width: 179,
                height: 179,
                text:url , // 二维码地址
                colorDark: "#000",
                colorLight: "#fff",
            });
        },
        savePreviewDraft(){
            let publicStatus = this.contextStatus ? 1 : 0;
            let data = new FormData()
            data.append('mainTitle',this.contextTitle)
            data.append('context',this.context)
            data.append('mainType','1')
            data.append('geo',this.geo)
            data.append('geoName',this.geoName)
            data.append('bubblePicture',this.contextImg)
            data.append('simpleInfo',this.contextBrief)
            data.append('publicStatus',publicStatus)
            data.append('progressStatus',0)
            if(this.contextId !=''){
                data.append('infoId',this.contextId)
            }
            this.$axios.post('/authorApi/main-info/editMainInfo',data)
                .then((res)=>{
                    this.showDialog = false
                    if(res.data.status == 200){
                        this.contextId=res.data.data
                        //草稿成功
                      this.$store.state.snackbarShow=true
                      this.$store.state.snackbarText = "草稿已保存"
                      this.$store.state.snackbarType = 'success'
                    }else{
                      this.$store.state.snackbarShow=true
                      this.$store.state.snackbarText = "保存失败，请稍后重试"
                      this.$store.state.snackbarType = 'error'

                    }
                })
        },

        //复制方法
        doCopy(){
          let _this = this
            let reg=new RegExp("https://market.obs.cn-north-4.myhuaweicloud.com:443/yingxiangku","g"); //创建正则RegExp对象
            let context = this.context.replace(reg,'https://market.obs.cn-north-4.myhuaweicloud.com:443/yingxiangkuMark')
          this.$copyText(context).then(function () {
            _this.$store.state.snackbarShow=true
            _this.$store.state.snackbarText = "已复制到剪贴板，请粘贴使用"
            _this.$store.state.snackbarType = 'success'
          },function () {
            _this.$store.state.snackbarShow=true
            _this.$store.state.snackbarText = "复制失败，请检查内容"
            _this.$store.state.snackbarType = 'error'

          })
        },
        //保存草稿
        saveDraft(){
          if(this.contextTitle == ''){
              this.snackbarColor='#CF0000'
              this.snackbar = true
              this.snackbarText = '无法保存，请输入标题'
          }else if(this.contextTitle.length >20){
              this.snackbarColor='#CF0000'
              this.snackbar = true
              this.snackbarText = '标题长度不能超过20字'
          }else if(this.contextBrief == ''){
              this.snackbarColor='#CF0000'
              this.snackbar = true
              this.snackbarText = '无法保存，请输入简介'
          }else if(this.contextBrief.length >40){
              this.snackbarColor='#CF0000'
              this.snackbar = true
              this.snackbarText = '简介长度不能超过40字'
          } else{
              this.addMainInfo(0)
          }
        },
        //提交文章
        summitInfo(){
            if(this.contextTitle == ''){
                this.snackbarColor='#CF0000'
                this.snackbar = true
                this.snackbarText = '无法提交，请输入标题'
            }else if(this.contextTitle.length >20){
                this.snackbarColor='#CF0000'
                this.snackbar = true
                this.snackbarText = '标题长度不能超过20字'
            } else if(this.context == ''){
                this.snackbarColor='#CF0000'
                this.snackbar = true
                this.snackbarText = '无法提交，请输入正文'
            }else if(this.contextBrief == ''){
                this.snackbarColor='#CF0000'
                this.snackbar = true
                this.snackbarText = '无法提交，请输入简介'
            } else if(this.contextImg == ''){
                this.snackbarColor='#CF0000'
                this.snackbar = true
                this.snackbarText = '无法提交，请选择封面'
            }else if(this.contextBrief.length > 40){
                this.snackbarColor='#CF0000'
                this.snackbar = true
                this.snackbarText = '简介长度不能超过40字'
            } else if(this.geo == ''){
                this.snackbarColor='#CF0000'
                this.snackbar = true
                this.snackbarText = '无法提交，请选择定位'
            }else{
                this.addMainInfo(2)
            }
        },
        //添加文章方法：提交，保存草稿
        addMainInfo(progressStatus){
        this.showDialog = true
            let publicStatus = this.contextStatus ? 1 : 0;
            let data = new FormData()
            data.append('mainTitle',this.contextTitle)
            data.append('context',this.context)
            data.append('mainType','1')
            data.append('geo',this.geo)
            data.append('geoName',this.geoName)
            data.append('bubblePicture',this.contextImg)
            data.append('simpleInfo',this.contextBrief)
            data.append('publicStatus',publicStatus)
            data.append('progressStatus',progressStatus)
            if(this.contextId !=''){
                data.append('infoId',this.contextId)
            }
            this.$axios.post('/authorApi/main-info/editMainInfo',data)
            .then((res)=>{
                this.showDialog = false
                if(res.data.status == 200){
                     this.contextId=res.data.data
                    //草稿成功
                    if(progressStatus == '0'){
                        this.snackbarColor='#4CAF50'
                        this.snackbar = true
                        this.snackbarText = '保存成功，可在创作管理-草稿箱中进行查看'
                    }else{
                        //提交成功
                        this.snackbarColor='#4CAF50'
                        this.snackbar = true
                        this.snackbarText = '提交成功，可在创作管理中进行查看详情'
                        //一秒后跳转创作页面
                        window.onbeforeunload = null
                        setTimeout(()=>{
                          this.$router.push({
                            path:'/home',query: {goHome:'goCreationManage'}
                          })
                        },1000)
                    }
                }else{
                    this.snackbarColor='#CF0000'
                    this.snackbar = true
                    this.snackbarText = '保存失败，请稍后重试'
                }
            })
        },

        //编辑获取详情
        getMainInfo(infoId){
          this.$axios.get('/authorApi/main-info/getMainInfoInfoId',{
              params:{
                  infoId:infoId,
              }
          }).then((res)=>{
              if(res.data.status == 200){
                  this.contextTitle = res.data.data.mainTitle//标题
                  this.context = res.data.data.context//内容
                  this.contextImg = res.data.data.bubblePicture//封面
                  this.contextBrief = res.data.data.simpleInfo//简介
                  this.geo = res.data.data.geo//geo
                  this.geoName = res.data.data.geoName
                  this.contextStatus =  res.data.data.publicStatus == 1 ? true :false //公开状态
                  this.progressStatus = res.data.data.progressStatus
              }
          })
        },

        //标题插件
        changeTitle(value){
          this.contextTitle = value
        },
        addTitle(){
          setTimeout(function () {
              document.getElementsByClassName("tox-edit-area")[0].insertBefore(document.getElementById("editorArea_title"),
                  document.getElementsByClassName("tox-edit-area__iframe")[0])

          },500)
        },
        //封面与简介
        changeIntroduction(value){
            this.contextBrief = value;
        },
        editCoverOK(param){
            this.contextImg = param;
        },
        //定位与状态
        choosePositionOK(param){
            this.geoName = param.city + " · " + param.name;
            this.geo = JSON.stringify({
                "type": "Point",
                "coordinates": [param.lng, param.lat]
            })
        },
        changePublicStatus(param){
            this.contextStatus = param;
        },

    },
      //取消页面监听刷新与关闭
      beforeDestroy() {
          window.onbeforeunload = null
      },
      mounted () {
      tinymce.init({})
          this.addTitle()

        //适配4k屏
        setTimeout(()=>{
          document.getElementById("articleEditor").querySelector(".tox-tinymce").style.height = document.getElementById("articleEditor").offsetHeight + "px"
          window.scrollTo(0,0)
        },100)




        //监听页面关闭
        window.onbeforeunload = function (e) {
            var message = '您是否确认离开此页面-您输入的数据可能不会被保存';
            e = e || window.event;
            if (e) {
                e.returnValue = message;
            }
            return "您是否确认离开此页面-您输入的数据可能不会被保存";
        }
          if(this.$route.query.creationId !='' && this.$route.query.creationId != null && typeof(this.$route.query.creationId) != "undefined"){
              this.contextId = this.$route.query.creationId
              this.getMainInfo(this.$route.query.creationId)
          }
    },

}
</script>

<style scoped>
  #contentStyle>>>img {
    width: 100%;
    height: auto;
  }

  /*定义滚动条宽高及背景，宽高分别对应横竖滚动条的尺寸*/
  ::-webkit-scrollbar {
      width: 7px; /*对垂直滚动条有效*/
      height: 7px;  /*对水平滚动条有效*/
  }
  /*定义滚动条的轨道颜色、内阴影及圆角*/
  ::-webkit-scrollbar-track {
      background-color: #FFFFFF;
  }
  /*定义滑块颜色、内阴影及圆角*/
  ::-webkit-scrollbar-thumb {
      background-color: rgba(166, 166, 166, 1);
  }
</style>
<style lang="scss">
    .preDialog{
    box-shadow: none;
  }

  #articleEditor .tox-tinymce{
    //删除外边框
    border: none !important;

    //适配4k屏
    min-height: 800px;
  }
  #articleEditor .tox .tox-editor-header{
    //工具栏充满
    width: 100% !important;
    //工具栏吸附顶部
    position: fixed !important;
  }
  #articleEditor .tox .tox-toolbar__primary{
    //修改编译器toolbar颜色 删除线
    background: rgba(245, 245, 245, 1) none !important;
  }
  #articleEditor .tox .tox-toolbar__group{
    //按钮组居中
    text-align: center !important;
    margin: 0 auto !important;
  }
  #articleEditor .tox .tox-sidebar-wrap{
    //设置背景色
    background: rgba(249, 249, 249, 1) none !important;
  }

  #articleEditor .tox .tox-edit-area{
    //编辑区距离顶部距离
    margin-top: 80px !important;
    //子元素居中
    justify-content: center !important;
  }
  #articleEditor .tox .tox-edit-area__iframe{
    //中间输入区宽度
    width: 840px !important;
      margin-top: 90px !important;
    //min-height: 900px !important;
    //背景色
    background: white !important;
    //阴影
    box-shadow: 4px 8px 10px 1px rgba(166, 166, 166, 0.25) !important;

  }
  #articleEditor .mce-content-body{
      overflow: hidden !important;
  }
    #articleEditor .mce-content-body:not([dir=rtl])[data-mce-placeholder]:not(.mce-visualblocks)::before{
        left: 100px !important;
    }


</style>

<style>

</style>
